import { create } from 'zustand';

import { ICameraGeometryPoint } from '~/Scene/System/systemCamera';
import { _system } from '~/Services/Studio/studioScene';

type TScreenshotCallback= (geometry: ICameraGeometryPoint) => void
interface IScreenshotContext {
    screenshotCallback: TScreenshotCallback,
    setScreenshotCallback: (screenshotCallback: TScreenshotCallback) => void,
    screenshot: () => void,
}

export const useScreenshotState = create<IScreenshotContext>((set, get) => ({
    screenshotCallback: null,
    setScreenshotCallback: (
        screenshotCallback: TScreenshotCallback,
    ) => set(() => ({ screenshotCallback })),
    screenshot: () => {
        const geometry = _system.getCurrentCameraGeometry();
        let e = get()
        e.screenshotCallback(geometry)
    }
}));
